import mudd from "../images/itsme.png";
import proje4 from "../components/assets/img/project/proj-4.webp";
import proje2 from "../components/assets/img/project/proj-2.webp";
import proje3 from "../components/assets/img/project/proj-3.webp";
import proje5 from "../components/assets/img/project/proj-5.webp";
import proje1 from "../components/assets/img/project/proj-1.webp";
import proje6 from "../components/assets/img/project/proj-6.webp";
import proje7 from "../components/assets/img/project/proj-7.webp";
import proje8 from "../components/assets/img/project/proj-8.webp";
import proje0 from "../components/assets/img/project/proj-9.webp";
import innerTwoProject03 from "../components/assets/img/project/inner_two_project03.jpg";
import testimonialAvatar1 from '../components/assets/img/images/testimonial_avatar01.png';
import testimonialAvatar2 from '../components/assets/img/images/testimonial_avatar02.png';
import testimonialAvatar3 from '../components/assets/img/images/testimonial_avatar03.png';
import cellularIMG from "../components/assets/img/project/cellular-optics.webp";
import cellercertifiedIMG from '../components/assets/img/project/celler-certified.webp';
import skuopticsdIMG from '../components/assets/img/project/sku-optics.webp';
import outsetIMG from '../components/assets/img/project/out-set.webp';
import recommercedIMG from '../components/assets/img/project/upcycle-it.webp';
import chronoIMG from '../components/assets/img/project/crown-chrono.webp';
import ASdesignIMG from '../components/assets/img/project/AS-design.webp';
import nexusperformanceIMG from '../components/assets/img/project/nexus-performance.webp';
export let info = {
  firstName: "Muddassir",
  lastName: "Hassan",
  position: "Frontend UX/UI Designer and Full Stack Developer",
  portfoliohead: "It’s all about my Passion",
  selfPortrait: mudd,
  miniBio: [
    {
      text: "become energetic with RC Cars",
    },

    {
      text: "free no - yes I am a freelancer",
    },
    {
      text: "me@genxsmedia.com",
    },
  ],
  socials: [
    {
      link: "https://facebook.com",
      icon: "fa fa-facebook",
      label: "facebook",
    },
    {
      link: "https://instagram.com",
      icon: "fa fa-instagram",
      label: "instagram",
    },
    {
      link: "https://github.com",
      icon: "fa fa-github",
      label: "github",
    },
    {
      link: "https://linkedin.com",
      icon: "fa fa-linkedin",
      label: "linkedin",
    },
    {
      link: "https://twitter.com",
      icon: "fa fa-twitter",
      label: "twitter",
    },
  ],
  bio: "Hi guys ! This is MUDD here as my friends call me. On papers though the world knows me as Muddassir. Who am I? To put it short, the answer to your questions, the solution to your problems, the way out for your business miseries. The graphic designer and front-end developer who has delivered nothing short of the very best to his hundreds of satisfied clients the world over since my companys inception in 2006. Looking forward for not a business collaboration but a life long friendship as I don’t make clients. I just make friends.",
  skills: {
    proficientWith: [
      "html5",
      "CSS3",
      "git",
      "github",
      "bootstrap",
      "react",
      "figma",
      "xd",
    ],
    exposedTo: ["adobe photoshop", "adobe illustrator"],
  },
  portfolio: [
    {
      title: "LAZY5VETS",
      live: "https://lazy5vets.com/",
      image:
        "https://genxsmedia.com/wp-content/uploads/2019/02/lazy5vets-1.jpg",
    },
    {
      title: "KETTLE CORN NYC",
      live: "https://www.kettlecornnyc.com/",
      image: "https://genxsmedia.com/wp-content/uploads/2019/11/kettlecorn.jpg",
    },
    {
      title: "LEPTOURGOS BABY",
      live: "http://babyleptourgos.com/",
      image: "https://genxsmedia.com/wp-content/uploads/2019/11/baby.jpg",
    },
    {
      title: "WELCH'S GIG",
      live: "http://welchsgig.com/",
      image: "https://genxsmedia.com/wp-content/uploads/2019/11/Layer-8.png",
    },
  ],
  services: [
    {
      image:
        "https://genxsmedia.com/wp-content/uploads/2019/02/lazy5vets-1.jpg",
      title: "Design",
      speciality: [
        "India",
        "Australia",
        "England",
        "South Africa",
        "West Indies",
        "Newzealand",
      ],
    },
    {
      title: "Project 2",
      live: "https://paytonpierce.dev",
      image:
        "https://genxsmedia.com/wp-content/uploads/2019/02/lazy5vets-1.jpg",
    },
    {
      title: "Project 3",
      live: "https://paytonpierce.dev",
      image:
        "https://genxsmedia.com/wp-content/uploads/2019/02/lazy5vets-1.jpg",
    },
    {
      title: "Project 4",
      live: "https://paytonpierce.dev",
      image:
        "https://genxsmedia.com/wp-content/uploads/2019/02/lazy5vets-1.jpg",
    },
    {
      title: "Project 5",
      live: "https://paytonpierce.dev",
      image:
        "https://genxsmedia.com/wp-content/uploads/2019/02/lazy5vets-1.jpg",
    },
  ],
  projects: [
    [
      {
        id: 1,
        title: "BuyBack X",
        image: proje4,
        description: "NextJS, MangoDB",
        link: "https://buybackxstores.com/",
      },
      {
        id: 2,
        title: "Celler Certified",
        image: proje6,
        description: "ReactJS, MangoDB",
        link: "https://www.cellercertified.com/",
      },
      {
        id: 2,
        title: "Celler Certifieds",
        image: proje6,
        description: "ReactJS, MangoDB",
        link: "https://www.cellercertified.com/",
      },
    ],
    [
        {
          id: 1,
          title: "LAZY5VETS",
          image: proje7,
          description: "Explore cutting-edge motion graphics design.",
          link: "https://lazy5vets.com/",
        },
        {
          id: 2,
          title: "cfgdrfgerg",
          image: proje8,
          description: "Explore cutting-edge motion graphics design.",
          link: "https://lazy5vets.com/",
        },
      ],
      [
        {
          id: 1,
          title: "LAZY5VETS",
          image: proje0,
          description: "Explore cutting-edge motion graphics design.",
          link: "https://lazy5vets.com/",
        },
        {
          id: 2,
          title: "cfgdrfgerg",
          image: innerTwoProject03,
          description: "Explore cutting-edge motion graphics design.",
          link: "https://lazy5vets.com/",
        },
      ],
      [
        {
          id: 1,
          title: "LAZY5VETS",
          image: proje1,
          description: "Explore cutting-edge motion graphics design.",
          link: "https://lazy5vets.com/",
        },
        {
          id: 2,
          title: "cfgdrfgerg",
          image: innerTwoProject03,
          description: "Explore cutting-edge motion graphics design.",
          link: "https://lazy5vets.com/",
        },
      ],
      [
        {
          id: 1,
          title: "LAZY5VETS",
          image: proje2,
          description: "Explore cutting-edge motion graphics design.",
          link: "https://lazy5vets.com/",
        },
        {
          id: 2,
          title: "cfgdrfgerg",
          image: innerTwoProject03,
          description: "Explore cutting-edge motion graphics design.",
          link: "https://www.lazy5vets.com/",
        },
      ],
  ],
  works:[
    {
      "name": "Cellular Optics",
      "description": "Diagonastic Testing Software for Used Devices",
      "image": cellularIMG,
      "link": "https://cellularoptics.com/",
      "category": "Web Development",
      "technology": "React, Node.JS, MangoDB",
      "year": "2022"
  },
  {
      "name": "Celler Certified",
      "description": "Buy or Sell Used Devices With Confidence",
      "image": cellercertifiedIMG,
      "link": "https://www.cellercertified.com/",
      "category": "Web Development",
      "technology": "React, Node.JS, MangoDB",
      "year": "2022"
  },
  {
    "name": "SKU Optics",
    "description": "E-commerce Inventory Software Solution",
    "image":skuopticsdIMG,
    "link": "https://www.skuoptics.com/",
    "category": "Web Development",
    "technology": "NextJS, Node.JS, Express",
    "year": "2022"
},
{
  "name": "AS Design",
  "description": "Home Remodeling Solutions Provider in Long Island",
  "image":ASdesignIMG ,
  "link": "https://asdesignli.com/",
  "category": "Web Development",
  "technology": "WordPress, Divi Theme, Custom Design",
  "year": "2023"
},
{
  "name": "Recommerced",
  "description": "Solutions to repurpose their IT Assets",
  "image": recommercedIMG,
  "link": "https://www.skuoptics.com/",
  "category": "Web Development",
  "technology": "NextJS, Node.JS, Express",
  "year": "2023"
},
{
  "name": "Outset Ventures",
  "description": "Providing investment fund and a physical space for technology incubation.",
  "image": outsetIMG,
  "link": "https://outset.ventures/",
  "category": "Web Development",
  "technology": "WordPress, Divi Theme, Custom Design",
  "year": "2023"
},
{
  "name": "Crown Chrono Bands",
  "description": "Deals in Customized Bands of L:uxry Watches",
  "image": chronoIMG,
  "link": "https://www.crownchronobands.com/",
  "category": "Web Development",
  "technology": "WordPress, Divi Theme, Custom Design",
  "year": "2022"
},
{
  "name": "Nexus Performance",
  "description": "Professional GYM Trainner in Ottawa",
  "image": nexusperformanceIMG,
  "link": "http://www.nexusperformancecentre.ca/",
  "category": "Web Development",
  "technology": "WordPress, Divi Theme, Custom Design",
  "year": "2022"
},

  ],
  testimonials :[
    {
      quote: "Skilled web developer! Strong communication skills and fast delivery. I'll certainly be repeating business with them!",
      author: "Charles K",
      title: "CEO Quaint Energy",
      avatar: testimonialAvatar1
    },
    {
      quote: "They did a great job building our new website, we are very happy and it looks great. The price was great also.",
      author: "Tyson Bellamy",
      title: "CEO T Y",
      avatar: testimonialAvatar2
    },
    {
      quote: "Muhammad is a good guy. Does really excellent work and will definitely use again. He worked on some flash (not easy) and HTML elements. Very pro look.",
      author: "Phillip Colin",
      title: "P C",
      avatar: testimonialAvatar3
    },
    {
      quote: "Great web developer! Great communication and very quick! Definetly will do business again.",
      author: "Whilly Bermudez",
      title: "CEO. Whilly Bermudez",
      avatar: testimonialAvatar2
    },
    {
      quote: "Excellent vendor who works hard to complete the project on time and on budget. No complaints at all and would use again in the future.",
      author: "Dan G.",
      title: "DG45",
      avatar: testimonialAvatar3
    }
  ]
};
